<template>
	<div class="row mb-4">
		<div
			class="col-12 d-flex flex-column nowrap align-items-center justify-content-center"
		>
			<div class="text-center d-flex flex-column nowrap">
				<div class="weight-700 font-size-16 mb-3">
					{{ content.planner_notAvailableProduct }}
				</div>
				<div class="weight-700 font-size-16 mb-2">
					{{ content.planner_notAvailableChangeYourDates }}
				</div>
			</div>
			<div class="d-flex flex-column flex-md-row nowrap align-items-center">
				<a href="/">
					<div
						class="oops-btn mb-2 cursor-pointer button-primary primary-normal d-flex align-items-center justify-content-center p-3 mx-3"
					>
						<span class="text-center px-4">{{
							content.planner_notAvailableNewSearch
						}}</span>
					</div>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import store from "@/vue/planning/store/store";

export default {
	store,
	name: "OopsBanner2",
	props: {},
	components: {},
	computed: {
		...mapState(["content"]),
	},
	methods: {},
	watch: {},
	mounted() {
		return;
	},
};
</script>

<style scoped></style>
